<template>
    <div class="help-issue is-right pull-right" aria-label="help" :class="{'is-visible': hVisible}">
        <div id="overlay" class="is-visible" v-if="hVisible" v-on:click="toggleHelpForm"></div>
        <a href="#" class="toggle-help"
           v-on:click.prevent="toggleHelpForm">
            <b-icon icon="life-ring" size="is-small"></b-icon>
        </a>
        <div class="help-dropdown"
             v-on:keydown.esc="hVisible = false"
             v-if="hVisible">
            <div class="help-header">
                <h6 class="title is-6">
                    <label for="report">Report a Technical Issue</label>
                    <div class="has-text-right pull-right">
                        <b-tooltip label="Send an email to developers to open an Issue" position="is-left" type="is-white">
                            <b-icon icon="question-circle" size="is-small" />
                        </b-tooltip>
                    </div>
                </h6>
            </div>
            <div class="help-body">
                <b-loading :is-full-page="false" :active="loading" />
                <b-message v-if="submitted" type="is-success">Thanks! We'll get back to you soon.</b-message>
                <form v-on:submit.prevent="submitHelpRequest" v-if="!submitted">
                    <p><small><em>
                        Provide some details about an issue you're experiencing.
                        The more details you can provide, the better! This Report includes some
                        additional debug information about your current session.
                    </em></small></p>
                    <textarea v-model="report"
                              id="report"
                              ref="report"
                              class="textarea"
                              placeholder="The last thing I did was..."
                              required></textarea>
                    <br />
                    <b-button type="is-primary" native-type="submit" class="is-block">Submit Issue</b-button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import apiCall from '@/store/modules/call'
import { mapState } from 'vuex'

export default {
  name: 'Notifications',
  components: {
    //
  },
  data () {
    return {
      hVisible: false,
      loading: false,
      submitted: false,
      report: ''
    }
  },
  computed: {
    ...mapState({
      init: state => state.init.all,
      search: state => state.search
    })
  },
  watch: {
    hVisible: function (newVal, oldVal) {
      this.$nextTick(() => {
        if (newVal === true) this.$refs['report'].focus()
      })
    }
  },
  methods: {
    toggleHelpForm: function () {
      this.hVisible = !this.hVisible
      this.submitted = false
    },
    handleError (err) {
      if (err.hasOwnProperty('response')) {
        if (err.response.data.message === 'error') {
          this.$awn.warning(err.response.data.message)
        } else if (err.response.data.message) {
          this.$awn.alert(err.response.data.message)
        }
        if (err.response.data.errors) {
          for (let field in err.response.data.errors) {
            if (!err.response.data.errors.hasOwnProperty(field)) continue
            this.$set(this.fieldSet, field, {
              'type': 'is-danger',
              'message': err.response.data.errors[field][0]
            })
          }
        }
      } else {
        this.$awn.alert(err.toString())
      }
    },
    submitHelpRequest: function () {
      this.loading = true
      if (this.report === '') return

      const postData = {
        'state': {
          'init': this.init,
          'route': {
            'name': this.$route.name,
            'params': this.$route.params,
            'hash': this.$route.hash,
            'query': this.$route.query
          },
          'search': this.search
        },
        'url': this.$route.fullPath,
        'message': this.report
      }

      apiCall({ // Get signed URL to upload
        url: 'help',
        data: postData,
        method: 'POST'
      }).then(() => {
        this.report = ''
        this.submitted = true
        this.loading = false
      }).catch(err => {
        this.handleError(err)
      })
    }
  },
  created () {
    //
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/Help.vue